module.exports = __webpack_public_path__ + "static/media/JuruteraBudiman_preview.ec2e5941.jpg";